import { PhotosphereModel } from "./photosphere.model";
import { NurseryModel } from "./nursery.model";

export class ProductModel {
    public uuid: string;
    public name: string;
    public description: string;
    public price: string;

    public speCod: string;
    public varCod: string;
    public speDex: string;
    public speTrd: string;
    public speIng: string;
    public speFra: string;
    public speSin: string;
    public varDex: string;
    public varTrd: string;
    public varIng: string;
    public varFra: string;
    public imgPath: string;
    public detailUrl: string;
    public photospheres: PhotosphereModel[];
    public nurseries: NurseryModel[] = [];

    constructor(value: JSON) {
        this.uuid = value["idCod"];
        this.name = value["name"];
        this.description = value["description"];
        this.price = value["price"];

        this.speCod = value["speCod"];
        this.varCod = value["varCod"];
        this.speDex = value["speDex"];
        this.speTrd = value["speTrd"];
        this.speIng = value["speIng"];
        this.speFra = value["speFra"];
        this.speSin = value["speSin"];
        this.varDex = value["varDex"];
        this.varTrd = value["varTrd"];
        this.varIng = value["varIng"];
        this.varFra = value["varFra"];
        this.imgPath = value["imgPath"];
        this.detailUrl = value["detailUrl"];
        if(value["photospheres"]) {
            this.photospheres = [];
            for(const photosphere of value["photospheres"]) {
                this.photospheres.push(new PhotosphereModel(photosphere));
            }
        }
    }
}